import { ApiError } from "@vana/core";

export class ListQueueError extends ApiError {}

export class ListAmbassadorsError extends ApiError {}

export class ListAmbassadorLoadsError extends ApiError {}

export class AssignRequestError extends ApiError {}

export class GetDeliveryDetailError extends ApiError {}

export class ListAmbassadorZonesError extends ApiError {}

export class QueryQueueError extends ApiError {}
